<template>
  <el-form label-width="80px" @submit.native.prevent>
    <div v-show="!isCollapsed">

      <!-- <el-form-item label="產地">
        <div class="w-100">
          <el-select style="width: 100%;" filterable v-model="form.OriginInfoIDs" :multiple="true" placeholder="請選擇產地">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in originInfos"
              :key="'product-'+item.ID"
              :label="item.Tw.Title"
              :value="item.ID">
            </el-option>
          </el-select>
          <br>
          <p class="hint">設定過產地的商品，將會顯示於該場地情報下方</p>
        </div>
      </el-form-item> -->

      <el-form-item label="商品名稱">
        <el-input v-model="form[formKey].Name" @input="onTitleInput"></el-input>
        <br>
        <p class="hint">商品名稱不可包含以下3種字元 # 與 " 與 /</p>
      </el-form-item>

      <el-form-item label="商品描述">
        <el-input v-model="form[formKey].Description" type="textarea" autosize></el-input>
      </el-form-item>

      <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="el-upload-images"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genCoverImageFileParam())">
          <img
            ref="coverImg"
            v-show="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            @load="e => onImageLoaded(e, genCoverImageFileParam())"
            class="preview"
            :src="form[formKey]['coverObjectURL'] || form[formKey].CoverImageURLX1"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form[formKey].CoverImageURLX1 || form[formKey]['coverObjectURL'])" class="el-icon-upload"></i>
          <!-- <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div> -->
        </el-upload>


        <draggable v-model="form[formKey].imagesJsonArr"
          handle=".img-images">
          <img v-for="(img,idx) in form[formKey].imagesJsonArr" :key="`product-${formKey}-image-${idx}`"
            class="img-images"
            @dblclick="confirmDeleteImage(idx)"
            :src="img['@1']"/>
        </draggable>

        <br>
        <p class="hint">請上傳 1080x1080的圖片。連點可刪除圖片。</p>
      </el-form-item>

      <el-form-item v-show="!isTeamBuyingProduct" label="類別">
        <div class="w-100">
          <el-select style="width: calc(100% - 50px);margin-right: 22px;" filterable v-model="form[formKey].CategoryIDs" multiple :disabled="form.ProductType==1" placeholder="請選擇類別">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option-group
              v-for="obj in groupedCategories"
              :key="`product-category-group-${obj.group.ID}`"
              :label="obj.group['Title'+formKey]">
              <el-option
                v-for="item in obj.categories"
                :key="'productCategory-'+item.ID"
                :label="item['Title'+formKey]"
                :value="item.ID">
              </el-option>
            </el-option-group>
          </el-select>
          <el-button @click="openCategoryCreatorModal" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        </div>
      </el-form-item>

      <el-form-item v-show="!isTeamBuyingProduct" label="標籤">
        <div class="w-100">
          <el-select style="width: calc(100% - 50px);margin-right: 22px;" filterable v-model="form[formKey].TagIDs" multiple placeholder="請選擇標籤">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in tags"
              :key="'productTag-'+item.ID"
              :label="item['Title'+formKey]"
              :value="item.ID">
            </el-option>
          </el-select>
          <el-button @click="openTagCreatorModal" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        </div>
      </el-form-item>

      <!-- <el-form-item label="上架日期">
        <el-date-picker v-model="form[formKey].ReleaseAt" class="left" type="date" placeholder="選擇日期"></el-date-picker>
        <label class="el-form-item__label" style="width: 160px;">下架日期</label>
        <el-date-picker v-model="form[formKey].CloseAt" class="left" type="date" placeholder="選擇日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="預購商品" class="text-left">
        <el-switch
          v-model="form[formKey].IsPreOrderProduct"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item> -->
    </div>

    <div style="padding-left: 120px;" v-if="!isTeamBuyingProduct">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form[formKey].contentJsonArr" />
    </div>

    <product-tag-editor-modal :isShow="isShowTagAddeditModal" @close="isShowTagAddeditModal = false" @submitted="onTagAdded"/>
    <product-category-editor-modal :isShow="isShowCategoryAddeditModal" @close="isShowCategoryAddeditModal = false" @submitted="onCategoryAdded"/>

  </el-form>
</template>

<script>
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import ProductTagEditorModal from '@/data/productTag/view/editor-modal.vue'
import ProductCategoryEditorModal from '@/data/productCategory/view/editor-modal.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import draggable from 'vuedraggable'
export default {
  mixins: [MixinProcessImageFile],
  components: {
    ContentEditor,
    ProductTagEditorModal,
    ProductCategoryEditorModal,
    draggable
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    },
    formKey: {
      default: ''
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      isShowTagAddeditModal: false,
      isShowCategoryAddeditModal: false,
      // discount image
      isProcessingDiscountImage: false
    }
  },
  computed: {
    isTeamBuyingProduct () {
      return this.$route.name == 'createTeamBuyingProduct' || this.$route.name == 'updateTeamBuyingProduct'
    },
    originInfos () {
      return this.$store.state.originInfo.list
    },
    tags () {
      return this.$store.state.productTag.list
    },
    groupedCategories () {
      var arr = []
      let groups = this.$store.state.productCategoryGroup.list
      let categories = this.$store.state.productCategory.list
      for (let group of groups) {
        arr.push({
          group,
          categories: categories.filter(o => o.GroupID === group.ID)
        })
      }
      window.arr = arr
      return arr
    },
    isEdit () {
      return this.$route.name !== 'createProduct'
    }
  },
  methods: {
    onTagAdded (tag) {
      this.toggleTag(tag.ID)
    },
    openTagCreatorModal () {
      this.isShowTagAddeditModal = true
    },
    // tag
    toggleTag (id) {
      let idx = this.form[this.formKey].TagIDs.findIndex(o => o === id)
      if (idx >= 0) {
        this.form[this.formKey].TagIDs.splice(idx, 1)
      } else {
        this.form[this.formKey].TagIDs.push(id)
      }
    },

    onCategoryAdded (tag) {
      this.toggleCategory(tag.ID)
    },
    openCategoryCreatorModal () {
      this.isShowCategoryAddeditModal = true
    },
    // tag
    toggleCategory (id) {
      let idx = this.form[this.formKey].CategoryIDs.findIndex(o => o === id)
      if (idx >= 0) {
        this.form[this.formKey].CategoryIDs.splice(idx, 1)
      } else {
        this.form[this.formKey].CategoryIDs.push(id)
      }
    },
    // cover image
    genCoverImageFileParam () {
      let requiredSize = { w: 1080, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'elupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'coverImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'coverObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'CoverImageURLX3',
          'CoverImageURLX2',
          'CoverImageURLX1'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          },
          {
            maxWidth: requiredSize.w * 2 / 3,
            maxHeight: requiredSize.h * 2 / 3
          },
          {
            maxWidth: requiredSize.w / 3,
            maxHeight: requiredSize.h / 3
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'coverImageBlob@3x',
          'coverImageBlob@2x',
          'coverImageBlob@1x'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `product/${this.form.ID}/cover-`
            : `product/cover@3x-${this.form[this.formKey].Name}-`,
          this.isEdit
            ? `product/${this.form.ID}/cover-`
            : `product/cover@2x-${this.form[this.formKey].Name}-`,
          this.isEdit
            ? `product/${this.form.ID}/cover-`
            : `product/cove-@1x-${this.form[this.formKey].Name}-`
        ],
        // 上傳後 callback
        onImageUploaded: () => {
          let newImg = {
            '@3': this.form[this.formKey].CoverImageURLX3,
            '@2': this.form[this.formKey].CoverImageURLX2,
            '@1': this.form[this.formKey].CoverImageURLX1
          }
          if (!this.form[this.formKey].imagesJsonArr) {
            this.$set(this.form[this.formKey], 'imagesJsonArr', [newImg])
          } else {
            this.form[this.formKey].imagesJsonArr.push(newImg)
          }
          this.form[this.formKey].CoverImageURLX3 = ''
          this.form[this.formKey].CoverImageURLX2 = ''
          this.form[this.formKey].CoverImageURLX1 = ''
        }
      }
      return params
    },
    // discount image
    genDiscountImageFileParam () {
      let requiredSize = { w: 90, h: 90 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingDiscountImage',
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'el-upload-discount',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'discountImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey].Discount,
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'discountImageObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'discountImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `product/${this.form.ID}/discount-`
            : `product/discount-${this.form[this.formKey].Name}-`
        ]
      }
      return params
    },
    confirmDeleteImage (idx) {
      if (window.confirm('確定刪除此圖片?')) {
        this.form[this.formKey].imagesJsonArr.splice(idx, 1)
      }
    },
    onTitleInput () {
      this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/"/g, '')
      this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/#/g, '')
      this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/\//g, '')
      this.$emit('title-changed', this.form[this.formKey].Name)
    }
  },
  created () {
    this.form[this.formKey].contentJsonArr = this.form[this.formKey].Contents
      ? JSON.parse(this.form[this.formKey].Contents)
      : []
    this.form[this.formKey].imagesJsonArr = this.form[this.formKey].Images
      ? JSON.parse(this.form[this.formKey].Images)
      : []
    this.$set(this.form[this.formKey], 'coverObjectURL', this.form[this.formKey].CoverImageURLX3)
  }
}
</script>

<style>
.discount-wrapper {
  margin-top: 30px;
  padding: 25px 84px 25px 0;
  background-color: rgb(247, 247, 247);

  align-items: center;
  display: inline-flex;
}

.el-upload-discount {
  height: 90px;
  display: inline-block;
}

.el-upload-discount .el-upload-dragger {
  width: 90px;
  height: 90px;
}

.el-upload-discount .el-upload__text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: center;
  color: rgb(112, 112, 112);
}

.el-upload-images {
  height: 100px;
  float: left;
  display: inline-block;
}

.el-upload-images .el-upload-dragger {
  width: 100px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.el-upload-images .el-icon-upload {
  margin: 0 !important;
}

.img-images {
  width: 100px;
  height: 100px;
  display: inline-block;
  float: left;
  margin-left: 15px;
}

.hint {
  display: block;
  width: 100%;
  float: left;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  color: #666;
}
</style>
